import axios from "axios";

import {
  FacebookAdAccount,
  FacebookPage,
  FacebookPageFeedItem,
} from "../types/facebook";
import { IntegrationSchema } from "../types/integration";

export const getIntegrations = async (
  workspaceSlug: string,
): Promise<IntegrationSchema[]> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceSlug}/integrations`))
    .data;
};

export const connectIntegration = async (
  workspaceSlug: string,
  integration: string,
  context: Record<string, any>,
): Promise<Record<string, any>> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/integrations/${integration}`,
      { context },
    )
  ).data;
};

export const disconnectIntegration = async (
  workspaceSlug: string,
  integration: string,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspaceSlug}/integrations/${integration}`,
  );
};

export const getFacebookAdAccounts = async (
  workspaceSlug: string,
): Promise<FacebookAdAccount[]> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/integrations/facebook/ad-accounts`,
    )
  ).data;
};

export const getFacebookPages = async (
  workspaceSlug: string,
): Promise<FacebookPage[]> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/integrations/facebook/pages`,
    )
  ).data;
};

export const getFacebookPageFeed = async (
  page: FacebookPage,
): Promise<FacebookPageFeedItem[]> => {
  return (
    await axios.get(`https://graph.facebook.com/v21.0/${page.id}/feed`, {
      params: { access_token: page.access_token },
    })
  ).data.data;
};
